import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Form, Input, Button, Select, Row, Col, Card, message } from 'antd';
import {
  EditOutlined
} from "@ant-design/icons";

import { recordError } from '../../../utils/logService';

import service from '../../../services/citizenScienceService';
import { fieldValidity } from "./custom/projectEnum";

import {
  Messages,
  Notify,
  openNotification,
  RichTextEditor,
  util
} from '@seims/shared';

const Feedbacknotes = ({onStatusUpdate}) => {

  const [feedBack, setFeedBack] = useState(true);
  const [feedBackNotes, setFeedBackNotes] = useState(true);
  const [value, setValue] = useState();
  const [ValidStatus, setValidStatus] = useState(fieldValidity.SUCCESS);
  const [ValidNotesStatus, setValidNotesStatus] = useState(fieldValidity.SUCCESS);
  const [ValidityMsg, setValidityMsg] = useState("");
  const [ValidityNotesMsg, setValidityNotesMsg] = useState("");
  const [disabled, setDisabled] = useState(false);

  const formName = "FeedbacknotesForm";
  const [form] = Form.useForm();

  const { key } = useParams();
  const location = useLocation();
  let navigate = useNavigate();

  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const onSave = async () => {
    var msg;
    var action = "Project status";

    if (!form.getFieldValue('status')) {
      setValidityMsg("Review status is required");
      setValidStatus(fieldValidity.ERROR);
      return;
    }

    if (form.getFieldValue('status') === "Approve") {
      setValidityNotesMsg("");
      setValidNotesStatus(fieldValidity.SUCCESS);
    }
    else {
      const text = form.getFieldValue('notes')?.replace(/<(\/*)p[^>]*>/g, '').trim() || '';
      if (!form.getFieldValue('notes') || text.length < 5) {
        setValidityNotesMsg("Feedback notes are required, expects at least 5 character");
        setValidNotesStatus(fieldValidity.ERROR);
        return;
      }
    }

    const id = key.substring(key.indexOf("x") + 1, key.length);
    const data = {
      projectId: id,
      action: form.getFieldValue('status'),
      notes: form.getFieldValue('notes'),
    };

    var statusUpdate = form.getFieldValue('status') === "Approve" ? "Approved" : "Rejected";

    form.resetFields();
    setDisabled(true);
    // const hide = message.loading("Submitting in progress, please wait...", 0);
    try {
      const response = await service.updateProjectStatus(data);
      if (response.status === 200 || response.status === 201) {
        msg = util.parseMessages(Messages.UPDATE_STATUS, "Project", statusUpdate);
        openNotification(action, msg, Notify.SUCCESS);
       
        onStatusUpdate(response.data.value)  
        setValidityMsg("");
        setValidityNotesMsg("");
        // hide();
        setDisabled(false);
        return;
      }

      msg = util.parseMessages(Messages.UPDATE_FAILURE_STATUS, "Project", statusUpdate);
      openNotification(action, msg, Notify.ERROR);

    } catch (error) {

      msg = util.parseMessages(Messages.UPDATE_FAILURE_STATUS, "Project", statusUpdate);
      openNotification(action, msg, Notify.ERROR);

      recordError(error)

    }
  }

  const handleFeedbackChange = (value) => {
    setValue(value);
    form.setFieldsValue({ notes: value });
    setValidityNotesMsg("");
  }

  const onStatusChange = (value) => {
    setFeedBack(true)
    if (value) {
      setValidStatus(fieldValidity.SUCCESS)
      setValidityMsg("")
    };

    if (value === "Approve") {
      setValidNotesStatus(fieldValidity.SUCCESS)
      setValidityNotesMsg("");
      setFeedBackNotes(false);

    }

    if (value === "Revise" || value === "Reject") {
      setValidNotesStatus(fieldValidity.SUCCESS)
      setValidityMsg("")
      setValidityNotesMsg("");
      setFeedBackNotes(true);
    }

  }

  const returnHome = () => {
      const state = location?.state;
      if (state) {
        const { from } = state;
        navigate(from);
  
        const { currentPage, pageSize } =
          location.state?.data;
        navigate(from, {
          state: {
            currentPage: currentPage,
            pageSize: pageSize,
          },
        });
      } else {
        openNotification(
          "Candidates",
          "System is redirecting to candidate list",
          Notify.WARNING
        );
        navigate("/candidate", { replace: true });
  
        return;
      }
    };
  
    const onBackClick = () => {
      returnHome();
    };

  const statuses = [
    { label: 'Approved', value: 'Approve' },
    { label: 'Rejected', value: 'Reject' },
  ];


  return (
    <div>
      <Card title="Feedback Notes" bordered={true}>
        <Form
          {...formItemLayout}
          name={formName}
          form={form}
          layout="vertical"
          onFinish={onSave}
        >

          <Form.Item
            name="status"
            label="Review Status"
            validateStatus={ValidStatus}
            help={ValidityMsg}
            rules={[
              {
                required: feedBack,
                message: ValidityMsg,
              },
            ]}
          >
            <Select onChange={onStatusChange}
              placeholder="Please select review status"
              value={statuses.value}
              options={statuses}
            />
          </Form.Item>
          <Form.Item
            name="notes"
            label="Feedback Notes"

            validateStatus={ValidNotesStatus}
            help={ValidityNotesMsg}
            rules={[
              {
                required: feedBackNotes,
                message: ValidityNotesMsg,
              },
              {
                min: 10,
                message: "Please enter a longer description",
              },
            ]}
          >
            <RichTextEditor placeholder={'Please add feedback notes here...'} supportMultiMedia={false} value={value} onChange={handleFeedbackChange} />
          </Form.Item>
        </Form>
        <Row>
        </Row>
        <Row>
          <Col xs={24} className="right-align">
            <Button key="3a" type="primary" onClick={onSave} icon={<EditOutlined />} style={{ marginRight: 10 }} disabled={disabled}>Save</Button>&nbsp;
            <Button type="default" onClick={onBackClick}>Back</Button>
          </Col>
        </Row>
      </Card>

    </div>
  )
}

export default Feedbacknotes